export const PLACEHOLDER = "—";

export const UNKNOWN_USER = "Unknown user";

export const USER_TYPE_LABELS: Record<string, string> = {
  FACILITY_USER: "Facility User",
  SIGNATORY: "Signatory",
  FACILITY: "Facility",
  AGENT: "Agent",
};
